import _ from 'underscore';

import GatewayLSPaymentsViewController from 'app/src/controllers/settings/paymentProcessing/GatewayLSPaymentsViewController';
import GatewayTerminalListViewController from 'app/src/controllers/settings/paymentProcessing/GatewayTerminalListViewController';
import PaymentProcessingController from 'app/src/controllers/settings/paymentProcessing/PaymentProcessingController';
import CCTerminalCollection from 'app/src/data/models/CCTerminalCollection';
import GatewayConfigCollection from 'app/src/data/models/GatewayConfigCollection';
import PaymentProcessingLayout from 'app/src/views/settings/paymentProcessing/PaymentProcessingLayout';

export default class PaymentProcessingViewController extends PaymentProcessingController {
  /**
   * Constructs, gathers all the Gateways and the Terminals information to iterate through Gateways and create
   * ChildViews for each.
   *
   * @param gatewayConfigs {Collection}
   * @param ccTerminals {Collection}
   */
  constructor(gatewayConfigs, ccTerminals, lightspeedPaymentsAvailable = false) {
    if (
      !(gatewayConfigs instanceof GatewayConfigCollection) ||
      !(ccTerminals instanceof CCTerminalCollection)
    ) {
      throw 'A gateway and terminal collection must be specified';
    }

    super();

    /**
     * This is to remove the first empty Gateway which is attached
     * to a brand new user by default, but is invalid for real world use.
     */
    const filteredGatewayConfigs = new GatewayConfigCollection(
      gatewayConfigs.filter(
        (gatewayConfig) =>
          !(
            (gatewayConfig.get('name') === '' && gatewayConfig.get('gatewayConfigID') === 1) ||
            gatewayConfig.get('gatewayID') === 'lightspeed-payments'
          )
      )
    );

    this._gatewayConfigs = filteredGatewayConfigs;
    this._ccTerminals = ccTerminals;
    this._lightspeedPaymentsAvailable = lightspeedPaymentsAvailable;

    // initialize the controller's managed view.
    // We need viewData here for the Handlebars logic which shows a message if there are no Gateways.
    this.view = new PaymentProcessingLayout({
      viewData: {
        gatewaysExist: this._gatewayConfigs.length,
        hasLightspeedPaymentsAvailable: this._lightspeedPaymentsAvailable,
        readOnly: window.merchantos?.session?.isReadOnly() || false,
      },
    });
  }

  /**
   * Show method that initiates the GatewayTerminalListViewController (which displays a single Gateway listing)
   * to be attached to a dynamically created region, with the id of gateway-${gatewayID}.
   * We pass the gateway (for the info), terminal (to list the associated Terminal attached to this gateway)
   * and the shop (to create a Last Used Shop location entry).
   */
  show() {
    super.show();

    if (this._gatewayConfigs.length) {
      this._gatewayConfigs.forEach((gateway) => {
        const gatewayID = gateway.id;
        const terminals = new CCTerminalCollection(
          this._ccTerminals.filter((terminal) => terminal.get('gatewayConfigID') === gatewayID)
        );
        const gatewayRegion = `gateway-${gatewayID}`;

        this.createRegion(gatewayRegion, 'div.listings');
        this.attachChildViewController(
          new GatewayTerminalListViewController(gateway, terminals),
          gatewayRegion
        );
      });
    }
  }
}
